import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { ROUTESLIST } from '@/static/urls';

import './card.scss';

export default class AlbomCard extends Component {
    render() { 
        const { image, title, authors, year } = this.props;  //id, 
        
        const url =  ROUTESLIST.ALBOM;      
        return (
            <div className="albom-card">
                <div className="albom-card__content">
                    <Link to={ url } className="albom-card__img">
                        <img src={image} alt={ title } />                        
                    </Link>                    
                    <div className="albom-card__info">               
                        <Link to={ url } className="albom-card__title">
                            { title }
                        </Link>
                        <div className="albom-card__authors">
                           by { authors }
                        </div>
                        <div className="albom-card__year">
                           { year }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
